import { autoinject } from 'aurelia-framework';
import { ProductionOrderTabProps } from '../tabs';

@autoinject
export class Tab {
  data: ProductionOrderTabProps;

  activate(data: ProductionOrderTabProps) {
    this.data = data;
  }
}
